<script>
  import { createEventDispatcher, getContext } from "svelte";
  import debounce from "lodash/debounce";
  import CustomIcon from "../CustomIcon.svelte";

  const { onFormChange, form } = getContext("form");
  const dispatch = createEventDispatcher();
  const debounceTimeMs = 500;

  export let value;
  export let readonly = false;
  export let formDetection = true;
  export let type = "text";
  export let disabled = false;
  export let placeholder = "";
  export let gray = false;
  export let appendPrefix = undefined;
  export let prefix = undefined;
  export let name;
  export let step = undefined;
  export let max = undefined;
  export let min = undefined;
  export let small = false;
  export let addDebounce = true;
  export let isClearable = true;
  export let inputClass = "" ;

  function handleDataChange(event) {
    if (formDetection) onFormChange(event);
    dispatch("change", event);
  }

  function typeAction(node) {
    node.type = type;
  }
  function clearInput() {
    value = null;
    onDebounce({ name, value });
  }

  const onDebounce = debounce((event) => {
    handleDataChange(event);
  }, debounceTimeMs);
</script>

<div
  class={`flex relative border border-field-border-gray rounded-md w-full ${
    small ? "h-8" : "h-12"
  }
    ${(gray || readonly || disabled) && " border-0 bg-gray-200"}`}
>
  {#if prefix}
    <span class="flex-none m-auto pl-2 text-sm text-gray-400">{prefix}</span>
  {/if}
  <input
    use:typeAction
    {readonly}
    {disabled}
    {placeholder}
    bind:value
    {min}
    {max}
    {step}
    {name}
    on:input={!addDebounce ? handleDataChange : onDebounce}
    class={`border-0 flex-auto rounded-md text-sm ${small? "w-20 px-1": "pl-4 pr-9" }
      ${(gray || readonly || disabled) && "bg-gray-200"} ${inputClass}`}
  />
  {#if appendPrefix}
    <span class="flex-none m-auto px-2 text-sm text-gray-400">{appendPrefix}</span>
  {/if}

  <slot />
  {#if isClearable && value && !(gray || readonly || disabled)}
    <button
      on:click={clearInput}
      class="px-1.5 font-bold border-0"
    >
      <CustomIcon
        name="close_notification"
        label="Clear"
        width={20}
        color="black"
        height={20}
      />
    </button>
  {/if}
</div>

<style>
  .autocomplete-clear-button {
    cursor: pointer;
    display: block;
    text-align: center;
    position: absolute;
    right: 0.1em;
    bottom: 0.1em;
    -webkit-transform: translateY(-50%);
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
    z-index: 2;
  }
</style>
